export default __webpack_public_path__ + "static/phillips-48dd88392f839dc53983017b036fcc57.jpg";